export default {
  defaultProps: {
    size: 'lg',
  },
  sizes: {
    '4xl': {
      fontSize: { base: '6xl', md: '7xl' },
      letterSpacing: 'xl',
    },
    '3xl': {
      fontSize: { base: '5xl', md: '6xl' },
      letterSpacing: 'xl',
    },
    '2xl': {
      fontSize: { base: '4xl', md: '5xl' },
    },
    xl: {
      fontSize: '3xl',
    },
    lg: {
      fontSize: { base: '2xl', md: '3xl' },
    },
    md: { fontSize: 'xl' },
    sm: { fontSize: 'md' },
    xs: { fontSize: 'sm' },
  },
  variants: {
    disabled: {
      color: 'muted.600',
    },
  },
}
